import { Directive, ElementRef, HostListener, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  standalone: true,
  selector: '[numericOnly]'
})
export class NumericOnlyDirective {

  constructor(private el: ElementRef, @Optional() private ngControl: NgControl) { }

  @HostListener('input') onInput() {
    const inputElement = this.el.nativeElement;
    const newValue = inputElement.value.replace(/[^0-9]/g, '');

    if (this.ngControl?.control) {
      this.ngControl.control.setValue(newValue, { emitEvent: true });
    } else {
      inputElement.value = newValue;
    }
  }
}